import { Box, Button, CloseButton, Flex, Stack, Text } from '@mantine/core';
import { FieldValues, useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormControlInput, TextInputControl } from '@/core/components';

export interface ListInputControlProps<T extends FieldValues> extends Omit<FormControlInput<T>, 'name'> {
  label: string;

  name: string;

  description?: string;
  isDisabled?: boolean;
}

const defaultObject = {
  name: '',
};

export function GovNotFulfilledListSelectControl<T extends FieldValues>(props: ListInputControlProps<T>) {
  const { name, label, description, control, isDisabled, isSubmitting } = props;
  // @ts-expect-error weird type error
  const { fields, append, remove } = useFieldArray({ name, control: control, keyName: 'uuid' });
  const { t } = useTranslation();

  return (
    <Box>
      <Flex justify="space-between">
        <Box>
          <Text
            fw="500"
            size="xl"
          >
            {label}
          </Text>
          {description && <Text c="dimmed">{description}</Text>}
        </Box>
        <Button
          ml="15px"
          disabled={isDisabled}
          size="xs"
          // @ts-expect-error weird type
          onClick={() => append(defaultObject)}
        >
          {t('button.add')}
        </Button>
      </Flex>
      <Stack gap="sm">
        {fields.length === 0 && (
          <Text
            size="xs"
            c="dimmed"
            fs="italic"
          >
            Fără conținut
          </Text>
        )}
        {fields.map((field, index) => (
          <Flex
            align="center"
            justify="center"
            gap="4px"
            key={field.uuid}
          >
            <Text
              mr="8px"
              mt="25px"
              size="sm"
            >
              #{index + 1}
            </Text>
            {/* @ts-expect-error weird type error */}
            <TextInputControl
              label={t('govEvaluation.criteria')}
              name={`${name}.${index}.name`}
              control={control}
              isSubmitting={isSubmitting}
              isDisabled={isDisabled}
            />
            <CloseButton
              mt="25px"
              onClick={() => remove(index)}
              aria-label={t('govEvaluation.removeCriteria', { position: index + 1 })}
              c="red"
            />
          </Flex>
        ))}
      </Stack>
    </Box>
  );
}
